module.exports = "/assets/images/replay_9b25ff.svg";